// SHADOW MARKET™ — Patrones Gráficos i18n
// Pattern names + label dictionaries translated to ES / EN / SK.
// The pattern body (descripcion / estructura / objetivo / consejo)
// also has localized strings, indexed by pattern id.

export const PATRONES_UI = {
  es: {
    breadcrumb_academy: "Academia",
    breadcrumb_patterns: "Patrones",
    back_academy: "Academia",
    back_all: "Todos los patrones",
    nav_prev: "Anterior",
    nav_next: "Siguiente",
    nav_all: "Todos los patrones",
    tab_label: "Patrones",
    page_title: "Patrones Gráficos",
    page_subtitle: "Biblioteca visual · 16 patrones técnicos",
    eyebrow: "Biblioteca de Patrones",
    hero_title_html:
      '16 patrones que separan <span class="hl">al rebaño</span> del rebelde.',
    hero_sub:
      "Aprende a leer los gráficos como un analista institucional. Estructura, objetivo de precio y consejo pro para cada patrón. Filtra por tipo y nivel.",
    filter_type: "Tipo",
    filter_level: "Nivel",
    showing_template: (n, total) => `Mostrando ${n} de ${total} patrones`,
    empty: "No hay patrones que coincidan con esos filtros.",
    foot_hint: "Patrones complementarios a las 51 lecciones de la Academia",
    sec_description: "Descripción",
    sec_structure: "Estructura",
    sec_target: "Objetivo de precio",
    sec_tip: "Consejo Pro",
    card_cta: "Ver patrón",
    tipo: {
      todos: "Todos",
      continuacion: "Continuación",
      reversion: "Reversión",
      neutro: "Neutros",
    },
    tipo_badge: {
      continuacion: "Continuación",
      reversion: "Reversión",
      neutro: "Neutro",
    },
    direccion: { alcista: "Alcista", bajista: "Bajista", neutro: "Neutro" },
    nivel: {
      todos: "Todos los niveles",
      basico: "Básico",
      intermedio: "Intermedio",
    },
  },
  en: {
    breadcrumb_academy: "Academy",
    breadcrumb_patterns: "Patterns",
    back_academy: "Academia",
    back_all: "All patterns",
    nav_prev: "Previous",
    nav_next: "Next",
    nav_all: "All patterns",
    tab_label: "Patterns",
    page_title: "Chart Patterns",
    page_subtitle: "Visual library · 16 technical patterns",
    eyebrow: "Pattern Library",
    hero_title_html:
      '16 patterns that separate <span class="hl">the herd</span> from the rebel.',
    hero_sub:
      "Learn to read charts like an institutional analyst. Structure, price target and a pro tip for every pattern. Filter by type and level.",
    filter_type: "Type",
    filter_level: "Level",
    showing_template: (n, total) => `Showing ${n} of ${total} patterns`,
    empty: "No patterns match those filters.",
    foot_hint: "Complementary to the 51 lessons of the Academy",
    sec_description: "Description",
    sec_structure: "Structure",
    sec_target: "Price target",
    sec_tip: "Pro Tip",
    card_cta: "View pattern",
    tipo: {
      todos: "All",
      continuacion: "Continuation",
      reversion: "Reversal",
      neutro: "Neutral",
    },
    tipo_badge: {
      continuacion: "Continuation",
      reversion: "Reversal",
      neutro: "Neutral",
    },
    direccion: { alcista: "Bullish", bajista: "Bearish", neutro: "Neutral" },
    nivel: {
      todos: "All levels",
      basico: "Basic",
      intermedio: "Intermediate",
    },
  },
  sk: {
    breadcrumb_academy: "Akadémia",
    breadcrumb_patterns: "Vzory",
    back_academy: "Akadémia",
    back_all: "Všetky vzory",
    nav_prev: "Predošlý",
    nav_next: "Ďalší",
    nav_all: "Všetky vzory",
    tab_label: "Vzory",
    page_title: "Grafické vzory",
    page_subtitle: "Vizuálna knižnica · 16 technických vzorov",
    eyebrow: "Knižnica vzorov",
    hero_title_html:
      '16 vzorov, ktoré oddelia <span class="hl">stádo</span> od rebela.',
    hero_sub:
      "Nauč sa čítať grafy ako inštitucionálny analytik. Štruktúra, cieľ ceny a pro tip pre každý vzor. Filtruj podľa typu a úrovne.",
    filter_type: "Typ",
    filter_level: "Úroveň",
    showing_template: (n, total) => `Zobrazujem ${n} z ${total} vzorov`,
    empty: "Žiadne vzory nezodpovedajú týmto filtrom.",
    foot_hint: "Doplnok k 51 lekciám Akadémie",
    sec_description: "Popis",
    sec_structure: "Štruktúra",
    sec_target: "Cieľ ceny",
    sec_tip: "Pro Tip",
    card_cta: "Zobraziť vzor",
    tipo: {
      todos: "Všetky",
      continuacion: "Pokračovanie",
      reversion: "Obrat",
      neutro: "Neutrálne",
    },
    tipo_badge: {
      continuacion: "Pokračovanie",
      reversion: "Obrat",
      neutro: "Neutrálny",
    },
    direccion: { alcista: "Býčí", bajista: "Medvedí", neutro: "Neutrálny" },
    nivel: {
      todos: "Všetky úrovne",
      basico: "Základný",
      intermedio: "Pokročilý",
    },
  },
  "zh-CN": {
    breadcrumb_academy: "Academia",
    breadcrumb_patterns: "形态",
    back_academy: "Academia",
    back_all: "所有形态",
    nav_prev: "上一个",
    nav_next: "下一个",
    nav_all: "所有形态",
    tab_label: "形态",
    showing_template: (n, total) => `显示 ${total} 个形态中的 ${n} 个`,
    page_title: "图表形态",
    page_subtitle: "可视化图库 · 16种技术形态",
    eyebrow: "形态图库",
    hero_title_html: "16种将<span class=\"hl\">羊群</span>与叛逆者区分开的形态。",
    hero_sub: "像机构分析师一样解读图表。每种形态的结构、价格目标和专业建议。按类型和级别筛选。",
    filter_type: "类型",
    filter_level: "级别",
    empty: "没有符合这些筛选条件的形态。",
    foot_hint: "学院51节课程的补充形态",
    sec_description: "描述",
    sec_structure: "结构",
    sec_target: "价格目标",
    sec_tip: "专业建议",
    card_cta: "查看形态",
    tipo: {
      todos: "全部",
      continuacion: "持续",
      reversion: "反转",
      neutro: "中性",
    },
    tipo_badge: {
      continuacion: "持续",
      reversion: "反转",
      neutro: "中性",
    },
    direccion: {
      alcista: "看涨",
      bajista: "看跌",
      neutro: "中性",
    },
    nivel: {
      todos: "所有级别",
      basico: "基础",
      intermedio: "中级",
    },
  },
  de: {
    breadcrumb_academy: "Academia",
    breadcrumb_patterns: "Muster",
    back_academy: "Academy",
    back_all: "Alle Muster",
    nav_prev: "Zurück",
    nav_next: "Weiter",
    nav_all: "Alle Muster",
    tab_label: "Muster",
    showing_template: (n, total) => `${n} von ${total} Mustern werden angezeigt`,
    page_title: "Chart-Muster",
    page_subtitle: "Visuelle Bibliothek · 16 technische Muster",
    eyebrow: "Muster-Bibliothek",
    hero_title_html: "16 Muster, die <span class=\"hl\">die Herde</span> vom Rebellen trennen.",
    hero_sub: "Lerne Charts zu lesen wie ein institutioneller Analyst. Struktur, Kursziel und Profi-Tipp für jedes Muster. Filtern nach Typ und Level.",
    filter_type: "Typ",
    filter_level: "Level",
    empty: "Keine Muster entsprechen diesen Filtern.",
    foot_hint: "Muster ergänzend zu den 51 Lektionen der Academy",
    sec_description: "Beschreibung",
    sec_structure: "Struktur",
    sec_target: "Kursziel",
    sec_tip: "Profi-Tipp",
    card_cta: "Muster ansehen",
    tipo: {
      todos: "Alle",
      continuacion: "Fortsetzung",
      reversion: "Umkehr",
      neutro: "Neutral",
    },
    tipo_badge: {
      continuacion: "Fortsetzung",
      reversion: "Umkehr",
      neutro: "Neutral",
    },
    direccion: {
      alcista: "Bullisch",
      bajista: "Bearisch",
      neutro: "Neutral",
    },
    nivel: {
      todos: "Alle Level",
      basico: "Basis",
      intermedio: "Fortgeschritten",
    },
  },
};

// Localized pattern texts keyed by id × lang.
// Spanish is the source; EN/SK are professional translations of the same content.
export const PATRONES_TEXTS = {
  es: {
    "bandera-alcista": {
      nombre: "Bandera Alcista",
      descripcion:
        "Patrón de continuación alcista formado por un impulso fuerte al alza (el asta) seguido de una corrección en un canal bajista paralelo (la bandera). Indica una pausa antes de que la tendencia continúe al alza.",
      estructura: [
        "Asta: impulso alcista fuerte",
        "Canal correctivo bajista paralelo (la bandera)",
        "Ruptura al alza del canal con volumen",
      ],
      objetivo: "La altura del asta proyectada hacia arriba desde el punto de ruptura.",
      consejo:
        "Busca volumen decreciente durante la bandera y aumento en la ruptura. Más fiable en marcos de 4H o diario. Muy frecuente en BTC tras noticias positivas.",
    },
    "bandera-bajista": {
      nombre: "Bandera Bajista",
      descripcion:
        "Patrón de continuación bajista. Un impulso descendente fuerte (asta) seguido de una corrección al alza en canal paralelo (bandera). Señal de continuación de la tendencia bajista.",
      estructura: [
        "Asta: impulso bajista fuerte",
        "Canal correctivo alcista paralelo",
        "Ruptura a la baja del canal",
      ],
      objetivo: "La altura del asta proyectada hacia abajo desde el punto de ruptura.",
      consejo:
        "El canal correctivo debe mantenerse por debajo del 50% del asta. Si supera ese nivel el patrón pierde fiabilidad.",
    },
    "banderin-alcista": {
      nombre: "Banderín Alcista",
      descripcion:
        "Similar a la bandera alcista pero la corrección forma un triángulo convergente en vez de un canal paralelo. La consolidación es más compacta y la ruptura suele ser más explosiva.",
      estructura: [
        "Asta: impulso alcista",
        "Triángulo convergente de consolidación",
        "Ruptura al alza del triángulo",
      ],
      objetivo: "La altura del asta proyectada desde el vértice del triángulo hacia arriba.",
      consejo:
        "El triángulo debe formarse en la mitad superior del asta. Cuanto más cerca del vértice sea la ruptura, más potente suele ser el movimiento.",
    },
    "banderin-bajista": {
      nombre: "Banderín Bajista",
      descripcion:
        "Versión bajista del banderín. El triángulo convergente se forma tras un impulso bajista fuerte. Señal de continuación: la ruptura a la baja confirma el movimiento.",
      estructura: [
        "Asta: impulso bajista",
        "Triángulo convergente de consolidación",
        "Ruptura a la baja del triángulo",
      ],
      objetivo: "La altura del asta proyectada hacia abajo desde el vértice.",
      consejo:
        "Confirma con aumento de volumen en la ruptura. Los banderines en marcos cortos (15min-1H) son muy frecuentes en cripto.",
    },
    "taza-asa": {
      nombre: "Taza con Asa",
      descripcion:
        "Corrección suave en forma de U (la taza) seguida de una pequeña consolidación bajista (el asa). Uno de los patrones más estudiados en mercados alcistas.",
      estructura: [
        "Impulso alcista previo",
        "Corrección en forma de U (la taza)",
        "Pequeña corrección bajista (el asa)",
        "Ruptura por encima de la resistencia",
      ],
      objetivo: "La profundidad de la taza proyectada hacia arriba desde el nivel de resistencia.",
      consejo:
        "La taza debe ser redondeada (U), no en V. El asa no debe corregir más del 50% de la taza. Muy habitual en BTC en marcos semanales.",
    },
    "taza-asa-invertida": {
      nombre: "Taza con Asa Invertida",
      descripcion:
        "Versión bajista. La corrección forma una cúpula invertida seguida de una pequeña corrección alcista. Señal de continuación bajista.",
      estructura: [
        "Impulso bajista previo",
        "Corrección en forma de U invertida (cúpula)",
        "Pequeña corrección alcista (asa)",
        "Ruptura bajista del soporte",
      ],
      objetivo: "La profundidad de la cúpula proyectada hacia abajo desde el soporte.",
      consejo:
        "Frecuente en mercados bajistas prolongados. Confirmar con volumen creciente en la ruptura a la baja.",
    },
    "doble-techo": {
      nombre: "Doble Techo",
      descripcion:
        "Dos máximos consecutivos al mismo nivel con un mínimo intermedio. Señal de que los compradores no pueden superar esa resistencia. La ruptura bajo la línea de cuello confirma la reversión.",
      estructura: [
        "Primer máximo",
        "Corrección hasta la línea de cuello",
        "Segundo máximo al mismo nivel",
        "Ruptura bajista de la línea de cuello",
      ],
      objetivo: "Distancia entre el máximo y la línea de cuello, proyectada hacia abajo.",
      consejo:
        "El segundo máximo con menor volumen aumenta la fiabilidad. Confirmar con cierre bajo la línea de cuello.",
    },
    "doble-suelo": {
      nombre: "Doble Suelo",
      descripcion:
        "Dos mínimos consecutivos al mismo nivel con un máximo intermedio. Los vendedores no pueden empujar el precio bajo ese soporte. Ruptura alcista de la línea de cuello confirma la reversión.",
      estructura: [
        "Primer mínimo",
        "Rebote hasta la línea de cuello",
        "Segundo mínimo al mismo nivel",
        "Ruptura alcista de la línea de cuello",
      ],
      objetivo: "Distancia entre el mínimo y la línea de cuello, proyectada hacia arriba.",
      consejo:
        "Segundo mínimo con menor volumen es señal positiva. Confirmar con cierre por encima de la línea de cuello.",
    },
    "triple-techo": {
      nombre: "Triple Techo",
      descripcion:
        "Tres máximos al mismo nivel. Más fiable que el doble techo. Cada intento fallido de superar la resistencia incrementa la presión vendedora.",
      estructura: [
        "Tres máximos consecutivos al mismo nivel",
        "Dos correcciones intermedias",
        "Ruptura bajo la línea de cuello",
      ],
      objetivo: "Distancia entre el máximo y la línea de cuello, proyectada hacia abajo.",
      consejo: "Cuanto más tiempo tarde en formarse, más potente suele ser la caída posterior.",
    },
    "triple-suelo": {
      nombre: "Triple Suelo",
      descripcion:
        "Tres mínimos al mismo nivel. Una de las señales de reversión alcista más potentes. El soporte se refuerza con cada rebote.",
      estructura: [
        "Tres mínimos consecutivos al mismo nivel",
        "Dos rebotes intermedios",
        "Ruptura por encima de la línea de cuello",
      ],
      objetivo: "Distancia entre el mínimo y la línea de cuello, proyectada hacia arriba.",
      consejo:
        "En cripto, los triples suelos en soporte de largo plazo marcan con frecuencia suelos de mercado importantes.",
    },
    "cabeza-hombros": {
      nombre: "Cabeza y Hombros",
      descripcion:
        "El patrón de reversión más conocido. Tres máximos: el central (cabeza) supera a los dos exteriores (hombros) que están al mismo nivel. Ruptura bajo la línea de cuello confirma la reversión bajista.",
      estructura: [
        "Hombro izquierdo",
        "Cabeza (máximo superior)",
        "Hombro derecho (≈mismo nivel que el izquierdo)",
        "Línea de cuello + ruptura bajista",
      ],
      objetivo: "Distancia entre la cabeza y la línea de cuello, proyectada desde la ruptura.",
      consejo:
        "Línea de cuello inclinada al alza es más bajista. Volumen elevado en la ruptura confirma el patrón.",
    },
    "cabeza-hombros-inversos": {
      nombre: "C&H Inversos",
      descripcion:
        "Versión alcista del cabeza y hombros. Tres mínimos donde el central (cabeza) es el más bajo. La ruptura por encima de la línea de cuello señala una reversión alcista potente.",
      estructura: [
        "Hombro izquierdo",
        "Cabeza (mínimo inferior)",
        "Hombro derecho (≈mismo nivel que el izquierdo)",
        "Línea de cuello + ruptura alcista",
      ],
      objetivo: "Distancia entre la cabeza y la línea de cuello, proyectada hacia arriba.",
      consejo:
        "Uno de los patrones más fiables para identificar suelos. Busca volumen creciente en el hombro derecho y en la ruptura.",
    },
    "cuna-ascendente": {
      nombre: "Cuña Ascendente",
      descripcion:
        "Canal convergente inclinado al alza. Ambas líneas suben pero convergen: el precio tiene cada vez menos espacio para subir. Señal de reversión bajista.",
      estructura: [
        "Línea de resistencia alcista",
        "Línea de soporte alcista (con mayor pendiente)",
        "Convergencia de ambas líneas",
        "Ruptura a la baja",
      ],
      objetivo: "Altura de la base de la cuña proyectada hacia abajo desde el punto de ruptura.",
      consejo:
        "Las cuñas ascendentes aparecen frecuentemente al final de impulsos alcistas. Son señales de distribución institucional.",
    },
    "cuna-descendente": {
      nombre: "Cuña Descendente",
      descripcion:
        "Canal convergente inclinado a la baja. La presión vendedora se reduce con cada mínimo. Señal de reversión alcista: la ruptura al alza suele ser potente.",
      estructura: [
        "Línea de resistencia bajista",
        "Línea de soporte bajista (con menor pendiente)",
        "Convergencia de ambas líneas",
        "Ruptura al alza",
      ],
      objetivo: "Altura de la base de la cuña proyectada hacia arriba desde el punto de ruptura.",
      consejo:
        "Las cuñas descendentes en correcciones de tendencia alcista son señales de continuación muy fiables en BTC/ETH.",
    },
    triangulo: {
      nombre: "Triángulo Simétrico",
      descripcion:
        "Zona de consolidación con máximos decrecientes y mínimos crecientes. El precio se comprime hasta que la energía produce una ruptura. La dirección de la ruptura determina el objetivo.",
      estructura: [
        "Línea de resistencia bajista",
        "Línea de soporte alcista",
        "Convergencia hacia un vértice",
        "Ruptura (dirección indeterminada)",
      ],
      objetivo: "Altura de la base del triángulo proyectada en la dirección de la ruptura.",
      consejo:
        "El contexto determina la probabilidad: un triángulo en tendencia alcista suele romper al alza. Siempre confirma con cierre de vela fuera.",
    },
    rectangulo: {
      nombre: "Rectángulo",
      descripcion:
        "El precio oscila entre un soporte y una resistencia horizontales. Zona de acumulación o distribución. La dirección de la ruptura determina el sesgo y el objetivo.",
      estructura: [
        "Resistencia horizontal",
        "Soporte horizontal",
        "Oscilaciones entre ambas",
        "Ruptura (dirección indeterminada)",
      ],
      objetivo: "Altura del rectángulo proyectada en la dirección de la ruptura.",
      consejo:
        "En cripto, los rectángulos largos con volumen creciente en los mínimos suelen preceder rupturas alcistas potentes (acumulación institucional).",
    },
  },
  en: {
    "bandera-alcista": {
      nombre: "Bullish Flag",
      descripcion:
        "Bullish continuation pattern formed by a strong upward thrust (the pole) followed by a correction inside a parallel down-sloping channel (the flag). It signals a pause before the trend resumes higher.",
      estructura: [
        "Pole: strong bullish impulse",
        "Parallel descending corrective channel (the flag)",
        "Upside breakout of the channel with volume",
      ],
      objetivo: "The height of the pole projected upward from the breakout point.",
      consejo:
        "Look for decreasing volume during the flag and a surge on the breakout. Most reliable on 4H or daily timeframes. Common on BTC after positive news.",
    },
    "bandera-bajista": {
      nombre: "Bearish Flag",
      descripcion:
        "Bearish continuation pattern. A strong downward impulse (pole) followed by an up-sloping parallel-channel correction (the flag). Signals continuation of the downtrend.",
      estructura: [
        "Pole: strong bearish impulse",
        "Parallel ascending corrective channel",
        "Downside breakout of the channel",
      ],
      objetivo: "The height of the pole projected downward from the breakout point.",
      consejo:
        "The corrective channel should stay below 50% of the pole. If it retraces more, the pattern loses reliability.",
    },
    "banderin-alcista": {
      nombre: "Bullish Pennant",
      descripcion:
        "Similar to the bullish flag but the correction forms a converging triangle instead of a parallel channel. The consolidation is tighter and the breakout tends to be more explosive.",
      estructura: [
        "Pole: bullish impulse",
        "Converging consolidation triangle",
        "Upside breakout of the triangle",
      ],
      objetivo: "Height of the pole projected upward from the triangle apex.",
      consejo:
        "The triangle should form in the upper half of the pole. The closer to the apex the breakout occurs, the stronger the move usually is.",
    },
    "banderin-bajista": {
      nombre: "Bearish Pennant",
      descripcion:
        "Bearish version of the pennant. The converging triangle forms after a strong bearish impulse. Continuation signal: the downside breakout confirms the move.",
      estructura: [
        "Pole: bearish impulse",
        "Converging consolidation triangle",
        "Downside breakout of the triangle",
      ],
      objetivo: "Height of the pole projected downward from the apex.",
      consejo:
        "Confirm with rising volume on the breakout. Pennants on short timeframes (15min-1H) are very common in crypto.",
    },
    "taza-asa": {
      nombre: "Cup with Handle",
      descripcion:
        "Smooth U-shaped correction (the cup) followed by a small bearish consolidation (the handle). One of the most studied patterns in bullish markets.",
      estructura: [
        "Prior bullish impulse",
        "U-shaped correction (the cup)",
        "Small bearish correction (the handle)",
        "Breakout above resistance",
      ],
      objetivo: "Cup depth projected upward from the resistance level.",
      consejo:
        "The cup must be rounded (U), not V-shaped. The handle should not retrace more than 50% of the cup. Very common on weekly BTC charts.",
    },
    "taza-asa-invertida": {
      nombre: "Inverted Cup with Handle",
      descripcion:
        "Bearish version. The correction forms an inverted dome followed by a small bullish retracement. Bearish continuation signal.",
      estructura: [
        "Prior bearish impulse",
        "Inverted U-shaped correction (dome)",
        "Small bullish correction (handle)",
        "Bearish support break",
      ],
      objetivo: "Dome depth projected downward from the support level.",
      consejo: "Frequent in extended bear markets. Confirm with rising volume on the downside breakout.",
    },
    "doble-techo": {
      nombre: "Double Top",
      descripcion:
        "Two consecutive highs at the same level with an intermediate low. A sign that buyers can't push through that resistance. The break below the neckline confirms the reversal.",
      estructura: [
        "First high",
        "Correction down to the neckline",
        "Second high at the same level",
        "Bearish break of the neckline",
      ],
      objetivo: "Distance between the top and the neckline, projected downward.",
      consejo:
        "A second top with lower volume increases reliability. Confirm with a close below the neckline.",
    },
    "doble-suelo": {
      nombre: "Double Bottom",
      descripcion:
        "Two consecutive lows at the same level with an intermediate high. Sellers can't push price below that support. The bullish break of the neckline confirms the reversal.",
      estructura: [
        "First low",
        "Rebound up to the neckline",
        "Second low at the same level",
        "Bullish break of the neckline",
      ],
      objetivo: "Distance between the bottom and the neckline, projected upward.",
      consejo:
        "A second bottom with lower volume is positive. Confirm with a close above the neckline.",
    },
    "triple-techo": {
      nombre: "Triple Top",
      descripcion:
        "Three highs at the same level. More reliable than the double top. Every failed attempt at resistance ramps up selling pressure.",
      estructura: [
        "Three consecutive highs at the same level",
        "Two intermediate corrections",
        "Break below the neckline",
      ],
      objetivo: "Distance between the top and the neckline, projected downward.",
      consejo: "The longer it takes to form, the stronger the subsequent decline tends to be.",
    },
    "triple-suelo": {
      nombre: "Triple Bottom",
      descripcion:
        "Three lows at the same level. One of the most potent bullish reversal signals. Support strengthens with every bounce.",
      estructura: [
        "Three consecutive lows at the same level",
        "Two intermediate bounces",
        "Break above the neckline",
      ],
      objetivo: "Distance between the bottom and the neckline, projected upward.",
      consejo:
        "In crypto, triple bottoms on long-term support frequently mark important market lows.",
    },
    "cabeza-hombros": {
      nombre: "Head & Shoulders",
      descripcion:
        "The best-known reversal pattern. Three peaks: the center one (head) tops the two outer peaks (shoulders) which are at the same level. A break below the neckline confirms the bearish reversal.",
      estructura: [
        "Left shoulder",
        "Head (higher peak)",
        "Right shoulder (≈same level as the left)",
        "Neckline + bearish break",
      ],
      objetivo: "Distance between the head and the neckline, projected from the breakout.",
      consejo:
        "An up-sloping neckline is more bearish. High volume on the breakout confirms the pattern.",
    },
    "cabeza-hombros-inversos": {
      nombre: "Inverse H&S",
      descripcion:
        "Bullish version of head & shoulders. Three lows where the center one (head) is the lowest. A break above the neckline signals a powerful bullish reversal.",
      estructura: [
        "Left shoulder",
        "Head (lower low)",
        "Right shoulder (≈same level as the left)",
        "Neckline + bullish break",
      ],
      objetivo: "Distance between the head and the neckline, projected upward.",
      consejo:
        "One of the most reliable patterns for spotting bottoms. Look for rising volume on the right shoulder and the breakout.",
    },
    "cuna-ascendente": {
      nombre: "Rising Wedge",
      descripcion:
        "Up-sloping converging channel. Both lines rise but converge: price has less and less room to advance. Bearish reversal signal.",
      estructura: [
        "Up-sloping resistance line",
        "Up-sloping support line (steeper)",
        "Convergence of both lines",
        "Downside breakout",
      ],
      objetivo: "Height of the wedge base projected downward from the breakout.",
      consejo:
        "Rising wedges frequently appear at the end of bullish moves. They signal institutional distribution.",
    },
    "cuna-descendente": {
      nombre: "Falling Wedge",
      descripcion:
        "Down-sloping converging channel. Selling pressure decreases with each low. Bullish reversal signal: the upside breakout is usually powerful.",
      estructura: [
        "Down-sloping resistance line",
        "Down-sloping support line (shallower)",
        "Convergence of both lines",
        "Upside breakout",
      ],
      objetivo: "Height of the wedge base projected upward from the breakout.",
      consejo:
        "Falling wedges inside corrections of bullish trends are very reliable continuation signals on BTC/ETH.",
    },
    triangulo: {
      nombre: "Symmetrical Triangle",
      descripcion:
        "Consolidation zone with lower highs and higher lows. Price compresses until energy produces a breakout. The breakout direction sets the target.",
      estructura: [
        "Down-sloping resistance line",
        "Up-sloping support line",
        "Convergence toward an apex",
        "Breakout (direction undetermined)",
      ],
      objetivo: "Height of the triangle base projected in the direction of the breakout.",
      consejo:
        "Context dictates the probability: a triangle in an uptrend usually breaks up. Always confirm with a candle close outside.",
    },
    rectangulo: {
      nombre: "Rectangle",
      descripcion:
        "Price oscillates between horizontal support and resistance. Zone of accumulation or distribution. The breakout direction sets the bias and the target.",
      estructura: [
        "Horizontal resistance",
        "Horizontal support",
        "Oscillations between both",
        "Breakout (direction undetermined)",
      ],
      objetivo: "Height of the rectangle projected in the direction of the breakout.",
      consejo:
        "In crypto, long rectangles with rising volume at the lows often precede powerful bullish breakouts (institutional accumulation).",
    },
  },
  sk: {
    "bandera-alcista": {
      nombre: "Býčia vlajka",
      descripcion:
        "Pokračovací býčí vzor tvorený silným pohybom nahor (žrď) a následnou korekciou v paralelnom klesajúcom kanáli (vlajka). Signalizuje pauzu pred pokračovaním trendu nahor.",
      estructura: [
        "Žrď: silný býčí impulz",
        "Paralelný klesajúci korekčný kanál (vlajka)",
        "Prelomenie kanála nahor s objemom",
      ],
      objetivo: "Výška žrde premietnutá nahor od bodu prelomenia.",
      consejo:
        "Sleduj klesajúci objem počas vlajky a nárast pri prelomení. Najspoľahlivejšie na 4H a denných grafoch. Časté na BTC po pozitívnych správach.",
    },
    "bandera-bajista": {
      nombre: "Medvedia vlajka",
      descripcion:
        "Pokračovací medvedí vzor. Silný klesajúci impulz (žrď) nasledovaný stúpajúcou paralelnou korekciou (vlajka). Signál pokračovania medvedieho trendu.",
      estructura: [
        "Žrď: silný medvedí impulz",
        "Paralelný stúpajúci korekčný kanál",
        "Prelomenie kanála nadol",
      ],
      objetivo: "Výška žrde premietnutá nadol od bodu prelomenia.",
      consejo:
        "Korekčný kanál sa musí udržať pod 50 % žrde. Ak ich prekročí, vzor stráca spoľahlivosť.",
    },
    "banderin-alcista": {
      nombre: "Býčí praporčík",
      descripcion:
        "Podobné býčej vlajke, ale korekcia tvorí konvergujúci trojuholník namiesto paralelného kanála. Konsolidácia je tesnejšia a prelomenie býva explozívnejšie.",
      estructura: [
        "Žrď: býčí impulz",
        "Konvergujúci konsolidačný trojuholník",
        "Prelomenie trojuholníka nahor",
      ],
      objetivo: "Výška žrde premietnutá nahor od vrcholu trojuholníka.",
      consejo:
        "Trojuholník by mal vznikať v hornej polovici žrde. Čím bližšie k vrcholu nastane prelomenie, tým silnejší býva pohyb.",
    },
    "banderin-bajista": {
      nombre: "Medvedí praporčík",
      descripcion:
        "Medvedia verzia praporčíka. Konvergujúci trojuholník vzniká po silnom medvedom impulze. Pokračovací signál: prelomenie nadol potvrdzuje pohyb.",
      estructura: [
        "Žrď: medvedí impulz",
        "Konvergujúci konsolidačný trojuholník",
        "Prelomenie trojuholníka nadol",
      ],
      objetivo: "Výška žrde premietnutá nadol od vrcholu.",
      consejo:
        "Potvrdiť rastúcim objemom pri prelomení. Praporčíky na krátkych časových rámcoch (15min-1H) sú v kryptomenách veľmi časté.",
    },
    "taza-asa": {
      nombre: "Šálka s držadlom",
      descripcion:
        "Plynulá korekcia v tvare U (šálka) nasledovaná malou medvedou konsolidáciou (držadlo). Jeden z najštudovanejších vzorov v býčích trhoch.",
      estructura: [
        "Predchádzajúci býčí impulz",
        "Korekcia v tvare U (šálka)",
        "Malá medvedia korekcia (držadlo)",
        "Prelomenie nad odpor",
      ],
      objetivo: "Hĺbka šálky premietnutá nahor od úrovne odporu.",
      consejo:
        "Šálka musí byť zaoblená (U), nie v tvare V. Držadlo nesmie korigovať viac ako 50 % šálky. Veľmi časté na týždennom grafe BTC.",
    },
    "taza-asa-invertida": {
      nombre: "Obrátená šálka s držadlom",
      descripcion:
        "Medvedia verzia. Korekcia tvorí obrátenú kupolu a malú býčiu korekciu. Pokračovací medvedí signál.",
      estructura: [
        "Predchádzajúci medvedí impulz",
        "Obrátená korekcia v tvare U (kupola)",
        "Malá býčia korekcia (držadlo)",
        "Medvedie prelomenie podpory",
      ],
      objetivo: "Hĺbka kupoly premietnutá nadol od podpory.",
      consejo:
        "Časté v dlhotrvajúcich medvedích trhoch. Potvrdiť rastúcim objemom pri prelomení nadol.",
    },
    "doble-techo": {
      nombre: "Dvojitý vrchol",
      descripcion:
        "Dva po sebe idúce maximá na rovnakej úrovni s medzitým minimom. Signál, že kupujúci nedokážu prekonať odpor. Prelomenie pod líniu krku potvrdzuje obrat.",
      estructura: [
        "Prvé maximum",
        "Korekcia k línii krku",
        "Druhé maximum na rovnakej úrovni",
        "Medvedie prelomenie línie krku",
      ],
      objetivo: "Vzdialenosť medzi maximom a líniou krku, premietnutá nadol.",
      consejo:
        "Druhé maximum s nižším objemom zvyšuje spoľahlivosť. Potvrdiť zatvorením pod líniou krku.",
    },
    "doble-suelo": {
      nombre: "Dvojité dno",
      descripcion:
        "Dve po sebe idúce minimá na rovnakej úrovni s medzitým maximom. Predávajúci nedokážu posunúť cenu pod tú podporu. Býčie prelomenie línie krku potvrdzuje obrat.",
      estructura: [
        "Prvé minimum",
        "Odraz k línii krku",
        "Druhé minimum na rovnakej úrovni",
        "Býčie prelomenie línie krku",
      ],
      objetivo: "Vzdialenosť medzi minimom a líniou krku, premietnutá nahor.",
      consejo:
        "Druhé minimum s nižším objemom je pozitívne. Potvrdiť zatvorením nad líniou krku.",
    },
    "triple-techo": {
      nombre: "Trojitý vrchol",
      descripcion:
        "Tri maximá na rovnakej úrovni. Spoľahlivejší než dvojitý vrchol. Každý neúspešný pokus o prekonanie odporu zvyšuje tlak predávajúcich.",
      estructura: [
        "Tri po sebe idúce maximá na rovnakej úrovni",
        "Dve medzikorekcie",
        "Prelomenie pod líniu krku",
      ],
      objetivo: "Vzdialenosť medzi maximom a líniou krku, premietnutá nadol.",
      consejo: "Čím dlhšie sa formuje, tým silnejší býva následný pokles.",
    },
    "triple-suelo": {
      nombre: "Trojité dno",
      descripcion:
        "Tri minimá na rovnakej úrovni. Jeden z najsilnejších býčích obratových signálov. Podpora sa s každým odrazom posilňuje.",
      estructura: [
        "Tri po sebe idúce minimá na rovnakej úrovni",
        "Dva medziodrazy",
        "Prelomenie nad líniu krku",
      ],
      objetivo: "Vzdialenosť medzi minimom a líniou krku, premietnutá nahor.",
      consejo:
        "V kryptomenách trojité dná na dlhodobej podpore často označujú dôležité dná trhu.",
    },
    "cabeza-hombros": {
      nombre: "Hlava a ramená",
      descripcion:
        "Najznámejší obratový vzor. Tri vrcholy: centrálny (hlava) presahuje dva vonkajšie (ramená) na rovnakej úrovni. Prelomenie pod líniu krku potvrdzuje medvedí obrat.",
      estructura: [
        "Ľavé rameno",
        "Hlava (vyšší vrchol)",
        "Pravé rameno (≈rovnaká úroveň ako ľavé)",
        "Línia krku + medvedie prelomenie",
      ],
      objetivo: "Vzdialenosť medzi hlavou a líniou krku, premietnutá od prelomenia.",
      consejo:
        "Stúpajúca línia krku je medvedšia. Vysoký objem pri prelomení potvrdzuje vzor.",
    },
    "cabeza-hombros-inversos": {
      nombre: "Inverzná H&R",
      descripcion:
        "Býčia verzia hlavy a ramien. Tri minimá, kde centrálne (hlava) je najnižšie. Prelomenie nad líniu krku signalizuje silný býčí obrat.",
      estructura: [
        "Ľavé rameno",
        "Hlava (nižšie minimum)",
        "Pravé rameno (≈rovnaká úroveň ako ľavé)",
        "Línia krku + býčie prelomenie",
      ],
      objetivo: "Vzdialenosť medzi hlavou a líniou krku, premietnutá nahor.",
      consejo:
        "Jeden z najspoľahlivejších vzorov na identifikáciu dien. Hľadaj rastúci objem na pravom ramene a pri prelomení.",
    },
    "cuna-ascendente": {
      nombre: "Stúpajúci klin",
      descripcion:
        "Konvergujúci kanál naklonený nahor. Obe línie stúpajú, ale konvergujú: cena má stále menej priestoru. Signál medvedieho obratu.",
      estructura: [
        "Stúpajúca odporová línia",
        "Stúpajúca podporová línia (so strmším sklonom)",
        "Konvergencia oboch línií",
        "Prelomenie nadol",
      ],
      objetivo: "Výška základne klinu premietnutá nadol od bodu prelomenia.",
      consejo:
        "Stúpajúce kliny sa často objavujú na konci býčích pohybov. Sú signálmi inštitucionálnej distribúcie.",
    },
    "cuna-descendente": {
      nombre: "Klesajúci klin",
      descripcion:
        "Konvergujúci kanál naklonený nadol. Tlak predaja sa s každým minimom znižuje. Signál býčieho obratu: prelomenie nahor býva silné.",
      estructura: [
        "Klesajúca odporová línia",
        "Klesajúca podporová línia (s miernejším sklonom)",
        "Konvergencia oboch línií",
        "Prelomenie nahor",
      ],
      objetivo: "Výška základne klinu premietnutá nahor od bodu prelomenia.",
      consejo:
        "Klesajúce kliny v korekciách býčieho trendu sú veľmi spoľahlivé pokračovacie signály na BTC/ETH.",
    },
    triangulo: {
      nombre: "Symetrický trojuholník",
      descripcion:
        "Konsolidačná zóna s klesajúcimi maximami a stúpajúcimi minimami. Cena sa stláča, kým energia nespôsobí prelomenie. Smer prelomenia určuje cieľ.",
      estructura: [
        "Klesajúca odporová línia",
        "Stúpajúca podporová línia",
        "Konvergencia k vrcholu",
        "Prelomenie (neurčený smer)",
      ],
      objetivo: "Výška základne trojuholníka premietnutá v smere prelomenia.",
      consejo:
        "Kontext určuje pravdepodobnosť: trojuholník v stúpajúcom trende zvyčajne prelomí nahor. Vždy potvrď zatvorením sviečky.",
    },
    rectangulo: {
      nombre: "Obdĺžnik",
      descripcion:
        "Cena osciluje medzi horizontálnou podporou a odporom. Zóna akumulácie alebo distribúcie. Smer prelomenia určuje smer a cieľ.",
      estructura: [
        "Horizontálny odpor",
        "Horizontálna podpora",
        "Oscilácie medzi nimi",
        "Prelomenie (neurčený smer)",
      ],
      objetivo: "Výška obdĺžnika premietnutá v smere prelomenia.",
      consejo:
        "V kryptomenách dlhé obdĺžniky s rastúcim objemom na minimách často predchádzajú silné býčie prelomenia (inštitucionálna akumulácia).",
    },
  },
  de: {
      "bandera-alcista": {
        nombre: "Bullische Flagge",
        descripcion: "Bullisches Fortsetzungsmuster, das durch einen starken Aufwärtsimpuls (die Fahnenstange) gefolgt von einer Korrektur in einem parallelen bärischen Kanal (die Flagge) gebildet wird. Zeigt eine Pause an, bevor der Trend nach oben fortsetzt.",
        estructura: [
          "Fahnenstange: starker bullischer Impuls",
          "Paralleler bärischer Korrekturkanal (die Flagge)",
          "Ausbruch nach oben aus dem Kanal mit Volumen"
        ],
        objetivo: "Die Höhe der Fahnenstange, projiziert nach oben vom Ausbruchspunkt.",
        consejo: "Suche nach abnehmendem Volumen während der Flagge und Zunahme beim Ausbruch. Zuverlässiger in 4H- oder Tages-Timeframes. Sehr häufig bei BTC nach positiven Nachrichten."
      },
      "bandera-bajista": {
        nombre: "Bärische Flagge",
        descripcion: "Bärisches Fortsetzungsmuster. Ein starker Abwärtsimpuls (Fahnenstange) gefolgt von einer Aufwärtskorrektur in einem parallelen Kanal (Flagge). Signal für Fortsetzung des bärischen Trends.",
        estructura: [
          "Fahnenstange: starker bärischer Impuls",
          "Paralleler bullischer Korrekturkanal",
          "Ausbruch nach unten aus dem Kanal"
        ],
        objetivo: "Die Höhe der Fahnenstange, projiziert nach unten vom Ausbruchspunkt.",
        consejo: "Der Korrekturkanal sollte unter 50% der Fahnenstange bleiben. Überschreitet er dieses Niveau, verliert das Muster an Zuverlässigkeit."
      },
      "banderin-alcista": {
        nombre: "Bullischer Wimpel",
        descripcion: "Ähnlich der bullischen Flagge, aber die Korrektur bildet ein konvergierendes Dreieck statt eines parallelen Kanals. Die Konsolidierung ist kompakter und der Ausbruch meist explosiver.",
        estructura: [
          "Fahnenstange: bullischer Impuls",
          "Konvergierendes Konsolidierungsdreieck",
          "Ausbruch nach oben aus dem Dreieck"
        ],
        objetivo: "Die Höhe der Fahnenstange, projiziert vom Scheitelpunkt des Dreiecks nach oben.",
        consejo: "Das Dreieck sollte sich in der oberen Hälfte der Fahnenstange bilden. Je näher am Scheitelpunkt der Ausbruch erfolgt, desto kraftvoller ist meist die Bewegung."
      },
      "banderin-bajista": {
        nombre: "Bärischer Wimpel",
        descripcion: "Bärische Version des Wimpels. Das konvergierende Dreieck bildet sich nach einem starken bärischen Impuls. Fortsetzungssignal: der Ausbruch nach unten bestätigt die Bewegung.",
        estructura: [
          "Fahnenstange: bärischer Impuls",
          "Konvergierendes Konsolidierungsdreieck",
          "Ausbruch nach unten aus dem Dreieck"
        ],
        objetivo: "Die Höhe der Fahnenstange, projiziert nach unten vom Scheitelpunkt.",
        consejo: "Bestätige mit zunehmendem Volumen beim Ausbruch. Wimpel in kurzen Timeframes (15min-1H) sind sehr häufig in Krypto."
      },
      "taza-asa": {
        nombre: "Tasse mit Henkel",
        descripcion: "Sanfte U-förmige Korrektur (die Tasse), gefolgt von einer kleinen bärischen Konsolidierung (der Henkel). Eines der am meisten studierten Muster in Bullenmärkten.",
        estructura: [
          "Vorheriger bullischer Impuls",
          "U-förmige Korrektur (die Tasse)",
          "Kleine bärische Korrektur (der Henkel)",
          "Ausbruch über den Widerstand"
        ],
        objetivo: "Die Tiefe der Tasse, projiziert nach oben vom Widerstandsniveau.",
        consejo: "Die Tasse sollte abgerundet sein (U), nicht V-förmig. Der Henkel sollte nicht mehr als 50% der Tasse korrigieren. Sehr häufig bei BTC in Wochen-Timeframes."
      },
      "taza-asa-invertida": {
        nombre: "Umgekehrte Tasse mit Henkel",
        descripcion: "Bärische Version. Die Korrektur bildet eine umgekehrte Kuppel, gefolgt von einer kleinen bullischen Korrektur. Signal für bärische Fortsetzung.",
        estructura: [
          "Vorheriger bärischer Impuls",
          "Umgekehrte U-förmige Korrektur (Kuppel)",
          "Kleine bullische Korrektur (Henkel)",
          "Bärischer Ausbruch der Unterstützung"
        ],
        objetivo: "Die Tiefe der Kuppel, projiziert nach unten von der Unterstützung.",
        consejo: "Häufig in verlängerten Bärenmärkten. Mit zunehmendem Volumen beim Abwärtsausbruch bestätigen."
      },
      "doble-techo": {
        nombre: "Doppeltop",
        descripcion: "Zwei aufeinanderfolgende Hochs auf demselben Niveau mit einem dazwischenliegenden Tief. Signal dafür, dass die Käufer diesen Widerstand nicht überwinden können. Der Ausbruch unter die Nackenlinie bestätigt die Umkehr.",
        estructura: [
          "Erstes Hoch",
          "Korrektur bis zur Nackenlinie",
          "Zweites Hoch auf demselben Niveau",
          "Bärischer Ausbruch der Nackenlinie"
        ],
        objetivo: "Distanz zwischen dem Hoch und der Nackenlinie, nach unten projiziert.",
        consejo: "Das zweite Hoch mit geringerem Volumen erhöht die Zuverlässigkeit. Mit Schlusskurs unter der Nackenlinie bestätigen."
      },
      "doble-suelo": {
        nombre: "Doppelboden",
        descripcion: "Zwei aufeinanderfolgende Tiefs auf demselben Niveau mit einem dazwischenliegenden Hoch. Die Verkäufer können den Preis nicht unter diese Unterstützung drücken. Bullischer Ausbruch der Nackenlinie bestätigt die Umkehr.",
        estructura: [
          "Erstes Tief",
          "Erholung bis zur Nackenlinie",
          "Zweites Tief auf demselben Niveau",
          "Bullischer Ausbruch der Nackenlinie"
        ],
        objetivo: "Distanz zwischen dem Tief und der Nackenlinie, nach oben projiziert.",
        consejo: "Zweites Tief mit geringerem Volumen ist ein positives Signal. Mit Schlusskurs über der Nackenlinie bestätigen."
      },
      "triple-techo": {
        nombre: "Dreifach-Top",
        descripcion: "Drei Hochs auf demselben Niveau. Zuverlässiger als das Doppeltop. Jeder gescheiterte Versuch, den Widerstand zu durchbrechen, erhöht den Verkaufsdruck.",
        estructura: [
          "Drei aufeinanderfolgende Hochs auf demselben Niveau",
          "Zwei Zwischenkorrekturen",
          "Bruch unter die Nackenlinie"
        ],
        objetivo: "Abstand zwischen dem Hoch und der Nackenlinie, nach unten projiziert.",
        consejo: "Je länger die Bildung dauert, desto stärker ist in der Regel der anschließende Rückgang."
      },
      "triple-suelo": {
        nombre: "Dreifach-Boden",
        descripcion: "Drei Tiefs auf demselben Niveau. Eines der stärksten bullischen Umkehrsignale. Die Unterstützung wird mit jedem Rückprall verstärkt.",
        estructura: [
          "Drei aufeinanderfolgende Tiefs auf demselben Niveau",
          "Zwei Zwischenrückpraller",
          "Bruch über die Nackenlinie"
        ],
        objetivo: "Abstand zwischen dem Tief und der Nackenlinie, nach oben projiziert.",
        consejo: "Bei Krypto markieren Dreifach-Böden an langfristiger Unterstützung häufig wichtige Marktböden."
      },
      "cabeza-hombros": {
        nombre: "SKS-Formation",
        descripcion: "Das bekannteste Umkehrmuster. Drei Hochs: das mittlere (Kopf) übersteigt die beiden äußeren (Schultern), die auf demselben Niveau liegen. Ein Bruch unter die Nackenlinie bestätigt die bärische Umkehr.",
        estructura: [
          "Linke Schulter",
          "Kopf (höheres Hoch)",
          "Rechte Schulter (≈gleiches Niveau wie die linke)",
          "Nackenlinie + bärischer Bruch"
        ],
        objetivo: "Abstand zwischen dem Kopf und der Nackenlinie, vom Bruch aus projiziert.",
        consejo: "Eine nach oben geneigte Nackenlinie ist bärischer. Hohes Volumen beim Bruch bestätigt das Muster."
      },
      "cabeza-hombros-inversos": {
        nombre: "Inverse SKS-Formation",
        descripcion: "Bullische Version der SKS-Formation. Drei Tiefs, wobei das mittlere (Kopf) das tiefste ist. Der Bruch über die Nackenlinie signalisiert eine starke bullische Umkehr.",
        estructura: [
          "Linke Schulter",
          "Kopf (tieferes Tief)",
          "Rechte Schulter (≈gleiches Niveau wie die linke)",
          "Nackenlinie + bullischer Bruch"
        ],
        objetivo: "Abstand zwischen dem Kopf und der Nackenlinie, nach oben projiziert.",
        consejo: "Eines der zuverlässigsten Muster zur Identifizierung von Böden. Achte auf steigendes Volumen bei der rechten Schulter und beim Bruch."
      },
      "cuna-ascendente": {
        nombre: "Aufsteigender Keil",
        descripcion: "Konvergierender Kanal mit Aufwärtsneigung. Beide Linien steigen, konvergieren jedoch: Der Preis hat immer weniger Raum zum Steigen. Bärisches Umkehrsignal.",
        estructura: [
          "Bullische Widerstandslinie",
          "Bullische Unterstützungslinie (mit steilerer Steigung)",
          "Konvergenz beider Linien",
          "Ausbruch nach unten"
        ],
        objetivo: "Höhe der Keilbasis, projiziert nach unten vom Ausbruchspunkt.",
        consejo: "Aufsteigende Keile erscheinen häufig am Ende bullischer Impulse. Sie sind Signale institutioneller Distribution."
      },
      "cuna-descendente": {
        nombre: "Absteigender Keil",
        descripcion: "Konvergierender Kanal mit Abwärtsneigung. Der Verkaufsdruck verringert sich mit jedem Tief. Bullisches Umkehrsignal: Der Ausbruch nach oben ist meist kraftvoll.",
        estructura: [
          "Bärische Widerstandslinie",
          "Bärische Unterstützungslinie (mit geringerer Steigung)",
          "Konvergenz beider Linien",
          "Ausbruch nach oben"
        ],
        objetivo: "Höhe der Keilbasis, projiziert nach oben vom Ausbruchspunkt.",
        consejo: "Absteigende Keile in Korrekturen eines Aufwärtstrends sind sehr zuverlässige Fortsetzungssignale bei BTC/ETH."
      },
      triangulo: {
        nombre: "Symmetrisches Dreieck",
        descripcion: "Konsolidierungszone mit fallenden Hochs und steigenden Tiefs. Der Preis komprimiert sich, bis die Energie einen Ausbruch erzeugt. Die Ausbruchsrichtung bestimmt das Ziel.",
        estructura: [
          "Bärische Widerstandslinie",
          "Bullische Unterstützungslinie",
          "Konvergenz zu einem Scheitelpunkt",
          "Ausbruch (Richtung unbestimmt)"
        ],
        objetivo: "Höhe der Dreiecksbasis, projiziert in Richtung des Ausbruchs.",
        consejo: "Der Kontext bestimmt die Wahrscheinlichkeit: Ein Dreieck in einem Aufwärtstrend bricht meist nach oben aus. Bestätige immer mit Kerzenschluss außerhalb."
      },
      rectangulo: {
        nombre: "Rechteck",
        descripcion: "Der Preis oszilliert zwischen horizontaler Unterstützung und Widerstand. Zone der Akkumulation oder Distribution. Die Ausbruchsrichtung bestimmt die Tendenz und das Ziel.",
        estructura: [
          "Horizontaler Widerstand",
          "Horizontale Unterstützung",
          "Oszillationen zwischen beiden",
          "Ausbruch (Richtung unbestimmt)"
        ],
        objetivo: "Höhe des Rechtecks, projiziert in Richtung des Ausbruchs.",
        consejo: "In Krypto gehen lange Rechtecke mit steigendem Volumen an den Tiefs meist kraftvollen bullischen Ausbrüchen voraus (institutionelle Akkumulation)."
      }
    },
  "zh-CN": {
      "bandera-alcista": {
        nombre: "看涨旗形",
        descripcion: "看涨延续形态，由强劲的上涨冲动（旗杆）后跟随平行下降通道内的回调（旗面）组成。表明趋势在继续上涨前的暂停。",
        estructura: [
          "旗杆：强劲看涨冲动",
          "平行下降修正通道（旗面）",
          "伴随成交量向上突破通道"
        ],
        objetivo: "旗杆的高度从突破点向上投影。",
        consejo: "寻找旗面期间成交量递减，突破时成交量增加。在4H或日线时间框架更可靠。BTC在利好消息后非常常见。"
      },
      "bandera-bajista": {
        nombre: "看跌旗形",
        descripcion: "看跌延续形态。强劲的下跌冲动（旗杆）后跟随平行通道内的向上回调（旗面）。看跌趋势延续信号。",
        estructura: [
          "旗杆：强劲看跌冲动",
          "平行看涨修正通道",
          "向下突破通道"
        ],
        objetivo: "旗杆的高度从突破点向下投影。",
        consejo: "修正通道应保持在旗杆50%以下。如果超过该水平，形态可靠性降低。"
      },
      "banderin-alcista": {
        nombre: "看涨三角旗",
        descripcion: "类似于看涨旗形，但回调形成收敛三角形而非平行通道。盘整更紧凑，突破通常更具爆发力。",
        estructura: [
          "旗杆：看涨冲动",
          "收敛三角形盘整",
          "向上突破三角形"
        ],
        objetivo: "旗杆的高度从三角形顶点向上投影。",
        consejo: "三角形应在旗杆上半部分形成。突破越接近顶点，走势通常越强劲。"
      },
      "banderin-bajista": {
        nombre: "看跌三角旗",
        descripcion: "三角旗的看跌版本。收敛三角形在强劲看跌冲动后形成。延续信号：向下突破确认走势。",
        estructura: [
          "旗杆：看跌冲动",
          "收敛三角形盘整",
          "向下突破三角形"
        ],
        objetivo: "旗杆的高度从顶点向下投影。",
        consejo: "通过突破时成交量增加确认。短时间框架（15分钟-1小时）的三角旗在加密货币中非常常见。"
      },
      "taza-asa": {
        nombre: "杯柄形态",
        descripcion: "平滑的U形回调(杯身)后跟随一个小幅看跌整固(手柄)。牛市中最受研究的形态之一。",
        estructura: [
          "前期看涨冲动",
          "U形回调(杯身)",
          "小幅看跌回调(手柄)",
          "突破阻力位上方"
        ],
        objetivo: "杯身深度从阻力位水平向上投射。",
        consejo: "杯身应呈圆形(U形),而非V形。手柄回调不应超过杯身深度的50%。在BTC周线图上非常常见。"
      },
      "taza-asa-invertida": {
        nombre: "倒杯柄形态",
        descripcion: "看跌版本。回调形成倒圆顶后跟随一个小幅看涨回调。看跌延续信号。",
        estructura: [
          "前期看跌冲动",
          "倒U形回调(圆顶)",
          "小幅看涨回调(手柄)",
          "支撑位看跌突破"
        ],
        objetivo: "圆顶深度从支撑位向下投射。",
        consejo: "在持续熊市中常见。确认向下突破时成交量增加。"
      },
      "doble-techo": {
        nombre: "双顶",
        descripcion: "两个连续的高点处于同一水平,中间有一个低点。表明买方无法突破该阻力位。跌破颈线确认反转。",
        estructura: [
          "第一个高点",
          "回调至颈线",
          "第二个高点处于同一水平",
          "颈线看跌突破"
        ],
        objetivo: "高点与颈线之间的距离向下投射。",
        consejo: "第二个高点成交量较低会增加可靠性。确认收盘价低于颈线。"
      },
      "doble-suelo": {
        nombre: "双底",
        descripcion: "两个连续的低点处于同一水平,中间有一个高点。卖方无法将价格推低至该支撑位下方。颈线看涨突破确认反转。",
        estructura: [
          "第一个低点",
          "反弹至颈线",
          "第二个低点处于同一水平",
          "颈线看涨突破"
        ],
        objetivo: "低点与颈线之间的距离向上投射。",
        consejo: "第二个低点成交量较低是积极信号。确认收盘价高于颈线。"
      },
      "triple-techo": {
        nombre: "三重顶",
        descripcion: "三个相同水平的高点。比双顶更可靠。每次未能突破阻力位都会增加卖压。",
        estructura: [
          "三个连续的相同水平高点",
          "两次中间回调",
          "跌破颈线"
        ],
        objetivo: "高点与颈线之间的距离，向下投影。",
        consejo: "形成时间越长，后续下跌通常越强劲。"
      },
      "triple-suelo": {
        nombre: "三重底",
        descripcion: "三个相同水平的低点。最强劲的看涨反转信号之一。支撑位随着每次反弹而加强。",
        estructura: [
          "三个连续的相同水平低点",
          "两次中间反弹",
          "突破颈线上方"
        ],
        objetivo: "低点与颈线之间的距离，向上投影。",
        consejo: "在加密货币中，长期支撑位上的三重底经常标志着重要的市场底部。"
      },
      "cabeza-hombros": {
        nombre: "头肩顶",
        descripcion: "最著名的反转形态。三个高点：中间的（头部）高于两侧的（肩部），两肩处于相同水平。跌破颈线确认看跌反转。",
        estructura: [
          "左肩",
          "头部（更高的高点）",
          "右肩（≈与左肩相同水平）",
          "颈线 + 看跌突破"
        ],
        objetivo: "头部与颈线之间的距离，从突破点向下投影。",
        consejo: "颈线向上倾斜更看跌。突破时成交量放大确认形态。"
      },
      "cabeza-hombros-inversos": {
        nombre: "头肩底",
        descripcion: "头肩顶的看涨版本。三个低点，中间的（头部）最低。突破颈线上方标志着强劲的看涨反转。",
        estructura: [
          "左肩",
          "头部（更低的低点）",
          "右肩（≈与左肩相同水平）",
          "颈线 + 看涨突破"
        ],
        objetivo: "头部与颈线之间的距离，向上投影。",
        consejo: "识别底部最可靠的形态之一。寻找右肩和突破时成交量增加。"
      },
      "cuna-ascendente": {
        nombre: "上升楔形",
        descripcion: "向上倾斜的收敛通道。两条线都上升但收敛：价格上涨空间越来越小。看跌反转信号。",
        estructura: [
          "看涨阻力线",
          "看涨支撑线（斜率更大）",
          "两条线收敛",
          "向下突破"
        ],
        objetivo: "楔形底部的高度从突破点向下投影。",
        consejo: "上升楔形经常出现在看涨冲动的末期。是机构派发的信号。"
      },
      "cuna-descendente": {
        nombre: "下降楔形",
        descripcion: "向下倾斜的收敛通道。每次低点的卖压都在减少。看涨反转信号：向上突破通常很强劲。",
        estructura: [
          "看跌阻力线",
          "看跌支撑线（斜率较小）",
          "两条线收敛",
          "向上突破"
        ],
        objetivo: "楔形底部的高度从突破点向上投影。",
        consejo: "在看涨趋势回调中的下降楔形是BTC/ETH中非常可靠的延续信号。"
      },
      triangulo: {
        nombre: "对称三角形",
        descripcion: "高点递减、低点递增的盘整区域。价格压缩直到能量产生突破。突破方向决定目标。",
        estructura: [
          "看跌阻力线",
          "看涨支撑线",
          "向顶点收敛",
          "突破（方向不确定）"
        ],
        objetivo: "三角形底部的高度向突破方向投影。",
        consejo: "背景决定概率：看涨趋势中的三角形通常向上突破。始终用K线收盘在外确认。"
      },
      rectangulo: {
        nombre: "矩形",
        descripcion: "价格在水平支撑位和阻力位之间震荡。吸筹或派发区域。突破方向决定偏向和目标。",
        estructura: [
          "水平阻力位",
          "水平支撑位",
          "在两者之间震荡",
          "突破（方向不确定）"
        ],
        objetivo: "矩形的高度向突破方向投影。",
        consejo: "在加密货币中，低点成交量递增的长矩形通常预示强劲的看涨突破（机构吸筹）。"
      }
    },
};

export function getPatronText(id, lang) {
  return (
    PATRONES_TEXTS[lang]?.[id] ||
    PATRONES_TEXTS.en?.[id] ||
    PATRONES_TEXTS.es[id] ||
    null
  );
}

export function getPatronesUi(lang) {
  return PATRONES_UI[lang] || PATRONES_UI.en || PATRONES_UI.es;
}
